import { cn } from '@/lib/utils';

interface ScreeningQuestionsProgressBarProps {
  percentage: number;
  backgroundColor: string | undefined;
  progressBarWidth: number;
}

function ScreeningQuestionsProgressBar({
  percentage,
  backgroundColor,
  progressBarWidth,
}: ScreeningQuestionsProgressBarProps) {
  return (
    <div className={cn('fixed left-0 right-0 overflow-hidden z-50 w-full h-6 top-0 bg-white/30')}>
      <div
        style={{
          width: `${progressBarWidth}%`,
          backgroundColor,
        }}
        className={cn(
          'flex w-full justify-center items-center h-6 transition-all duration-700 ease-in-out rounded-r-full',
          percentage === 100 && 'rounded-r-none',
        )}
      />
    </div>
  );
}

export default ScreeningQuestionsProgressBar;
